import { Injectable } from '@angular/core';
import { RefreshTokenRequestService } from '../../refresh-token/refresh-token-request.service';
import { RefreshTokenStorageService } from '../../refresh-token/refresh-token-storage.service';
import { AuthModule } from '../../auth.module';
import { AuthorityService } from '../../authority/authority.service';

@Injectable({
  providedIn: AuthModule
})
export class RefreshTokenGrantService {

  get path() {
    return this.refreshTokenRequestService.path;
  }

  constructor(private refreshTokenRequestService: RefreshTokenRequestService,
    private refreshTokenStorageService: RefreshTokenStorageService,
    private authorityService: AuthorityService) { }

  postRequest() {
    return this.authorityService.post<any>(this.path, this.createBody(), this.createOptions());
  }

  createOptions() {
    return this.refreshTokenRequestService.createOptions();
  }

  createBody() {
    return this.refreshTokenRequestService.createBody();
  }

  loadRefreshToken() {
    return this.refreshTokenStorageService.loadRefreshToken();
  }

  createRefreshTokenRequestUrl() {
    return this.authorityService.createResourceUrl(this.path);
  }
}
